import { LoggerErrorHandler } from "./shared/handle/logger-error-handler";
import { GlobalInterceptor } from "./shared/services/interceptors/global-interceptor";
import {
  NgModule,
  LOCALE_ID,
  ErrorHandler,
  APP_INITIALIZER,
} from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { environment } from "../environments/environment";
import { JwtInterceptor } from "./shared/services/interceptors/jwt-interceptor";
import { ErrorInterceptor } from "./shared/services/interceptors/error-interceptor";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ShareModule } from "./shared/share-module/share.module";
import { registerLocaleData } from "@angular/common";
import localeVi from "@angular/common/locales/vi";
import { appInitializer } from "./shared/util/CommonUtil";
import { DetectBrowser } from "./shared/layouts/detect-browser/detect-browser.component";

registerLocaleData(localeVi);
@NgModule({
  declarations: [AppComponent, DetectBrowser],
  entryComponents: [],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot({ animated: false }),
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFirestoreModule,
    ShareModule,
    BrowserAnimationsModule,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: GlobalInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: "vi-VN" },
    { provide: ErrorHandler, useClass: LoggerErrorHandler },
    // { provide: APP_INITIALIZER, useFactory: appInitializer, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
